import { cn } from '@/lib/cn';

type Props = {
  src?: string | null;
  name: string;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
};

const sizeClass = {
  sm: 'size-7 text-xs',
  md: 'size-9 text-sm',
  lg: 'size-20 text-xl',
};

export function Avatar({ src, name, size = 'md', className }: Props) {
  const initials = name
    .split(/\s+/)
    .map((p) => p[0])
    .filter(Boolean)
    .slice(0, 2)
    .join('')
    .toUpperCase();

  return (
    <span
      className={cn(
        'inline-flex shrink-0 select-none items-center justify-center overflow-hidden rounded-full bg-[var(--color-surface-muted)] font-medium text-[var(--color-foreground-muted)]',
        sizeClass[size],
        className,
      )}
    >
      {src ? (
        <img src={src} alt={name} className="size-full object-cover" />
      ) : (
        <span>{initials || '?'}</span>
      )}
    </span>
  );
}
